module.exports = {
  log: function(){}
}